<template>
  <div class="terms-follow-chips mt-6">
    <template v-if="status == 'success'">
      <TermFollowChip
        v-for="term in terms"
        :key="term.id"
        :term="term"
        class="inline-flex flex-nowrap items-center mr-4 mb-4 px-4 py-2 rounded-full"
      >
        <template v-slot:term-name>
          <span class="capitalize line-clamp-2">{{ term.name }}</span>
          <Icon name="plus" class="ml-2 text-black" />
        </template>
      </TermFollowChip>
    </template>

    <template v-else>
      <div
        v-for="i in 9"
        :key="i"
        class="inline-block mr-4 mb-4 h-10 w-28 bg-lightest-gray rounded-full animate-pulse"
      ></div>
    </template>
  </div>
</template>

<script>
import Icon from "@/components/Icons.vue";
import TermFollowChip from "@/templates/terms/TermFollowChip.vue";

export default {
  name: "TermsFollowChips",
  props: {
    terms: Array,
    status: String,
  },
  components: {
    Icon,
    TermFollowChip,
  },
  setup() {},
};
</script>
<style scoped>
.term-follow-chip {
  @apply bg-lighter-gray;
}

.term-follow-chip-processing {
  @apply opacity-50 cursor-not-allowed select-none;
}

.term-follow-chip-active {
  @apply bg-yka-blue text-white;
}

.term-follow-chip-active svg {
  display: none;
}
</style>
